module.exports = __webpack_public_path__ + "img/LCRG_Swords_03.6adeefb8.png";